import * as m from "mithril";
import { MessageProvider } from "../../context/AppMessages";
import TripItineraryView from "../../components/TripItineraryView";
import dayjs = require("dayjs");
import { getIntlStringValue } from "../../helpers/StringHelpers";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import { BookingDTO, InternationalStringDTO } from "../../apiclient/ApiDtos";
import { formatMoney } from "../../helpers/MoneyFormatter";
import { OrderedSeatsComponent } from "../pay/OrderedSeatComponent";
import { PickupDropOffDetailsComponent } from "../common/pickupdropoffInfo/PickupDropOffInfoDetails";
import { SeatsAutoAssignmentInfo } from "../pay/SeatsAutoAssignmentInfo";

export function tbRow(label: string | m.Vnode, valueContent: string | m.Vnode, valueContentAlignment?: "left" | "right") {
  let alignmentClass = (valueContentAlignment == "right") ? "text-end text-right" : "";
  return m("tr", [
    m("td.text-muted px-0", { style: "width:150px;word-break:break-word;" }, label),
    m("td.text-right", { "class": alignmentClass, style: "word-break:break-word;" }, valueContent)
  ]
  );
}


interface Attrs {
  messageProvider: MessageProvider,
  booking: BookingDTO
}

function ConfirmationDetails(): m.Component<Attrs> {
  return {
    view(vnode) {
      let currLang = vnode.attrs.messageProvider.getCurrentLang();

      let booking = vnode.attrs.booking;
      let messageProvider = vnode.attrs.messageProvider;
      let currentLan = vnode.attrs.messageProvider.getCurrentLang();
      /* let sourceName = getIntlStringValue(booking.trip.departure.location.name, currentLan);
      let destinationName = getIntlStringValue(booking.trip.arrival.location.name, currentLan);
      let noTravellerEmail = booking.traveller.email == "";
      let noTravellerSpecialRequest = booking.traveller.specialRequest == ""; */
      let trip = vnode.attrs.booking.trip;
      let traveller = vnode.attrs.booking.traveller;

      let hasPickupDropOffOrder = (booking.pickUpOrder != null && booking.pickUpOrder.lineItems.length > 0)
        || (booking.dropOffOrder != null && booking.dropOffOrder.lineItems.length > 0);

      let notices: InternationalStringDTO[] = booking.trip.notices || [];

      return m("div",
        [
          booking.status.toLowerCase() != 'confirmed' ?
            [
              m("div.my-2 px-3 py-2 rounded small custom-alert-info font-weight-bold",
                booking.trip.isSeatSelectionAllowed ? messageProvider.get("my_booking_details.processing_title") : messageProvider.get("seat_assignment_pending"),
                m("div.font-weight-normal mt-1", messageProvider.get("booking_confirmation.send_confirmation_info"))
              ),

            ]
            : null,
          m("div.card",
            [
              m("div.card-body", [
                booking.status.toLowerCase() != 'confirmed' ?
                  [
                    m("div.d-flex align-items-center text-righttext-end mb-2", {
                      style: "margin-top: -15px !important; color: rgb(189, 154, 17) !important;"
                    },
                      m("span.processing-loader"),
                      m("span.ml-2 pt-1 py-0 small rounded", messageProvider.get("my_bookings.processint_status")) //လုပ်ဆောင်နေဆဲ
                    ),
                  ]
                  : null,
                m("div.text-body-sm-",
                  m("span.text-primary -font-weight-bold",
                    getIntlStringValue(booking.trip.departure.location.name, currLang) + " - " + getIntlStringValue(booking.trip.arrival.location.name, currLang)),
                  m(CustomSvgIcon, {
                    iconType: 'circle_dot',
                    themeCssClass: "svg-muted svg-medium"
                  }),
                  m("span.text-primary --font-weight-bold", dayjs(booking.trip.departure.scheduledAt).format("MMM DD, hh:mm A"))
                ),
                m("div.mt-2 text-body-sm",
                  m("span", getIntlStringValue(booking.trip.operator.name, currLang)),
                  m("span", " | "),
                  m("span", getIntlStringValue(booking.trip.busType, currLang))
                ),
                m("div.mt-2 text-muted",
                  booking.referenceNumber != null ?
                    [
                      m("span.text-body-sm mr-1", "Ref #"),
                      m("span.text-body-sm", booking.referenceNumber),
                      " | "
                    ] : null,
                  m("span.text-body-sm", messageProvider.get("booking.purchased_date") + ": " + dayjs(booking.createdAt).format("YYYY/MM/DD hh:mm A")),

                  /* ((booking.pickUpOrder && booking.pickUpOrder.lineItems.length > 0) || (booking.dropOffOrder && booking.dropOffOrder.lineItems.length > 0)) ?
                    m("div.small text-success",
                      messageProvider.get("booking.ticket_price_pickup_dropoff_subtotal")
                    )
                    : */
                  m("div.small text-success font-weight-bold mt-1",
                    messageProvider.get("booking.total_payment_amount"),
                    "   :    ",
                    formatMoney(booking.paymentSummary.total)

                  )
                ),

                m("hr", { style: "border-top: 3px dotted #bbb;" }),

                m("div.mt-4 mb-3",
                  m("div", { class: "font-weight-bold" }, messageProvider.get("section.trip_summary_title"))
                ),

                m(TripItineraryView, { trip: vnode.attrs.booking.trip, messageProvider }),

                m("div.mt-4 small", [
                  m("div.text-muted", messageProvider.get("trip.route")),
                  m("div.mt-1", m("span", getIntlStringValue(trip.fullRouteName, currLang)))
                ]),

                m("div.mt-4 small", [
                  m("div.text-muted", messageProvider.get("operator.name")),
                  m("div.mt-1", [
                    m("span", getIntlStringValue(trip.operator.name, currLang)),
                    m("span", " | "),
                    m("span", getIntlStringValue(trip.busType, currLang)),
                  ])
                ]),

              ]),

              m("div.card-body border-top",
                m("div.small", [
                  m("div.text-muted", messageProvider.get("seat_selection.seat_count")),
                  m("div.mt-1", [
                    m("span", booking.seatOrder.seatSelections.length + " " + (booking.seatOrder.seatSelections.length > 1 ? messageProvider.get("seats") : messageProvider.get("seat"))),

                  ])
                ]),

                m("div.mt-4",
                  trip.isSeatSelectionAllowed ?
                    m(OrderedSeatsComponent, {
                      hideTotalTicketPrice: trip.hasPickUpService || trip.hasDropOffService,
                      messageProvider: messageProvider,
                      seatSelections: booking.seatOrder.seatSelections
                    })

                    :
                    m(SeatsAutoAssignmentInfo, {
                      messageProvider: messageProvider,
                      seatSelections: booking.seatOrder.seatSelections
                    })
                ),

                (notices.length > 0) ?
                  m("div", { class: "alert alert-info mt-3 mb-0 p-2" },
                    [
                      m("small.font-weight-bold",
                        messageProvider.get("trip.operator_notices", {
                          name: getIntlStringValue(booking.trip.operator.name, currLang)
                        })
                      ),
                      notices.map(notice => {
                        return m("div", { class: "small" }, "- " + getIntlStringValue(notice, currLang))
                      })
                    ]
                  )
                  : null,
              ),
              ((booking.pickUpOrder && booking.pickUpOrder.lineItems.length > 0) || (booking.dropOffOrder && booking.dropOffOrder.lineItems.length > 0)) &&
              m("div.card-body.border-top.px-2",
                m(PickupDropOffDetailsComponent, {
                  messageProvider: vnode.attrs.messageProvider,
                  totalNumberOfSeats: vnode.attrs.booking.seatOrder.numberOfSeats,
                  trip: vnode.attrs.booking.trip,
                  pickUpOrder: vnode.attrs.booking.pickUpOrder,
                  dropOffOrder: vnode.attrs.booking.dropOffOrder
                })
              ),

              m("div.card-body border-top",
                m("div.font-weight-bold mb-2",
                  messageProvider.get("section.traveller_info_title")
                ),
                m("table.table.table-borderless.table-striped1.table-sm",
                  m("tbody",
                    [
                      tbRow(messageProvider.get("traveller.name"), traveller.name),
                      tbRow(messageProvider.get("traveller.phone"), traveller.phoneNumber),
                      tbRow(messageProvider.get("traveller.email"),
                        (traveller.email) ? traveller.email :
                          m("span.text-muted", `(${messageProvider.get('traveller.no_fill')})`)
                      ),
                      //tbRow(messageProvider.get("traveller.special_request"), traveller.specialRequest),
                    ]
                  )
                ),

                m("div.font-weight-bold mt-4 mb-2",
                  messageProvider.get("traveller.special_request")
                ),
                (traveller.specialRequest) ?
                  m("div.mt-2", traveller.specialRequest) :
                  m("div.text-muted", `(${messageProvider.get('traveller.no_fill')})`)
              ),


              hasPickupDropOffOrder &&
              m("div.card-body border-top",
                m("div.font-weight-bold",
                  messageProvider.get("subtotal.seats_pickup_dropoff_amount_details")
                ),

                m("div.row.mt-3",
                  m(".col-6",
                    m("span.mr-2", messageProvider.get("total_seat_price"))
                  ),
                  m(".col-6.text-right",
                    m("span",
                      formatMoney(booking.seatOrder.totalAmount)
                    )
                  )
                ),

                (booking.pickUpOrder && booking.pickUpOrder.lineItems.length > 0) &&
                m("div.row.mt-3",
                  m(".col-6",
                    m("span.mr-2", messageProvider.get("total_pickup_fee"))
                  ),
                  m(".col-6.text-right",
                    m("span",
                      formatMoney(booking.pickUpOrder.totalAmount)
                    )
                  )
                ),

                (booking.dropOffOrder && booking.dropOffOrder.lineItems.length > 0) &&
                m("div.row.mt-3",
                  m(".col-6",
                    m("span.mr-2", messageProvider.get("total_dropoff_fee"))
                  ),
                  m(".col-6.text-right",
                    m("span",
                      formatMoney(booking.dropOffOrder!.totalAmount)
                    )
                  )
                ),

                m("div.row.mt-3 pt-3", {
                  style: "border-top: 1px dashed #a7b5d0ff !important"
                },
                  m(".col-6",
                    m("span.mr-2", messageProvider.get("total_seats_price_plus_pickup_dropoff_fee"))
                  ),
                  m(".col-6.text-right",
                    m("span.text-success.font-weight-bold",
                      formatMoney(booking.paymentSummary.subtotal)
                    )
                  )
                )
              ),
            ]
          ),
          m("div.card mt-3",
            [
              m("div.card-body", [
                m("div.font-weight-bold mt-1 mb-3",
                  messageProvider.get("section.payment_details")
                ),
                m("table.table.table-borderless.table-sm",
                  m("tbody",
                    [
                      tbRow(

                        ((booking.pickUpOrder && booking.pickUpOrder.lineItems.length > 0) || (booking.dropOffOrder && booking.dropOffOrder.lineItems.length > 0)) ?
                          messageProvider.get("booking.ticket_price_pickup_dropoff_subtotal") :
                          messageProvider.get("booking.ticket_price_subtotal")
                        ,

                        (booking.paymentSummary.subtotal != undefined && booking.paymentSummary.subtotal != null) ? formatMoney(booking.paymentSummary.subtotal, false) : formatMoney(booking.paymentSummary.total, false), "right"),

                      tbRow(messageProvider.get("booking.tax_amount"), "0", "right"),
                      tbRow(messageProvider.get("booking.discount_amount"), (booking.paymentSummary.discount != undefined && booking.paymentSummary.discount != null) ? "( - ) " + formatMoney(booking.paymentSummary.discount, false) : "0", "right"),
                    ]
                  )
                )
              ]),
              m("div.row mx-2 mt-0 mb-3",
                [
                  m("div.col.font-weight-bold fw-bold",
                    messageProvider.get("review.total_due")
                  ),
                  m("div.col.font-weight-bold fw-bold text-success text-end text-right",
                    formatMoney(booking.paymentSummary.total)
                  )
                ]
              )
            ]
          ),
        ]
      )
    }
  }
}

export default ConfirmationDetails;